import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DeleteAccount = () => {
  const [form, setForm] = useState({ name: "", phone: "", scope: "account", note: "" });
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");
  useEffect(() => { document.title = "حذف الحساب · جملتي"; }, []);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setState("loading");
    try {
      await axios.post(`${API}/public/account-deletion-request`, form);
      setState("done");
    } catch (ex) {
      setErr(ex.response?.data?.detail || "تعذر الإرسال، حاول مرة أخرى");
      setState("idle");
    }
  };

  return (
    <div dir="rtl" className="min-h-screen bg-[#FAFCFA] text-[#111814]">
      <div className="max-w-2xl mx-auto px-5 py-8 space-y-5">
        <div className="flex items-center gap-3">
          <img src="/jumlaty-icon-192.png" alt="جملتي" className="w-14 h-14 rounded-2xl shadow" />
          <div>
            <h1 className="text-3xl font-black text-[#1E3A5F]">طلب حذف الحساب والبيانات</h1>
            <p className="text-sm text-[#5C6E64]">تطبيق جملتي (Jumlaty) — فريق جملتي، بغداد، العراق</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-[#E4EBE6] p-5 space-y-3 leading-relaxed text-[15px]">
          <h2 className="font-black text-[#1E3A5F]">خطوات طلب الحذف</h2>
          <ol className="list-decimal pr-5 space-y-1">
            <li>اكتب اسمك ورقم الهاتف المسجّل بالتطبيق في النموذج أدناه.</li>
            <li>اختر: حذف الحساب كاملاً، أو حذف جزء من بياناتك فقط (مثل الموقع أو اسم المحل) مع بقاء الحساب.</li>
            <li>اضغط «إرسال الطلب». سنتواصل معك على رقمك للتأكد من هويتك، ويتم التنفيذ خلال 7 أيام.</li>
          </ol>
          <p>أو راسلنا مباشرة: <a href="mailto:mmujtabaa031@gmail.com" className="text-[#3B82F6] underline">mmujtabaa031@gmail.com</a></p>
          <h2 className="font-black text-[#1E3A5F] pt-2">ما الذي يُحذف وما الذي يُحتفظ به</h2>
          <ul className="list-disc pr-5 space-y-1">
            <li><strong>يُحذف نهائياً:</strong> الاسم، رقم الهاتف، اسم المحل، العنوان والموقع الجغرافي، كلمة المرور، رموز الإشعارات، رصيد المكافآت.</li>
            <li><strong>يُحتفظ به:</strong> الفواتير والمعاملات المالية فقط (بدون بيانات تعريفية) لمدة تصل إلى 5 سنوات، لأغراض المحاسبة والالتزامات القانونية، ثم تُحذف.</li>
          </ul>
        </div>

        {state === "done" ? (
          <div data-testid="delete-request-success" className="bg-emerald-50 border border-emerald-200 rounded-2xl p-5 text-emerald-800 font-bold text-center">
            ✓ تم استلام طلبك. سنتواصل معك خلال 7 أيام.
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white rounded-2xl border border-[#E4EBE6] p-5 space-y-3" data-testid="delete-request-form">
            <input required value={form.name} onChange={set("name")} placeholder="الاسم" data-testid="delete-request-name"
              className="w-full border-2 border-slate-200 rounded-xl px-3 py-2.5 focus:border-[#1E3A5F] outline-none" />
            <input required value={form.phone} onChange={set("phone")} placeholder="رقم الهاتف المسجّل (07xxxxxxxxx)" dir="ltr" inputMode="numeric"
              data-testid="delete-request-phone" className="w-full border-2 border-slate-200 rounded-xl px-3 py-2.5 text-right focus:border-[#1E3A5F] outline-none" />
            <select value={form.scope} onChange={set("scope")} data-testid="delete-request-scope"
              className="w-full border-2 border-slate-200 rounded-xl px-3 py-2.5 bg-white">
              <option value="account">حذف الحساب وكل البيانات</option>
              <option value="data">حذف جزء من البيانات فقط (بدون حذف الحساب)</option>
            </select>
            <textarea value={form.note} onChange={set("note")} rows={3} placeholder="ملاحظة (اختياري): ما البيانات التي تريد حذفها؟"
              data-testid="delete-request-note" className="w-full border-2 border-slate-200 rounded-xl px-3 py-2.5 focus:border-[#1E3A5F] outline-none" />
            {err && <p className="text-red-600 text-sm font-bold" data-testid="delete-request-error">{err}</p>}
            <button disabled={state === "loading"} data-testid="delete-request-submit"
              className="w-full bg-[#E85D45] hover:bg-[#d54d35] disabled:opacity-50 text-white font-black py-3 rounded-full transition-colors">
              {state === "loading" ? "جاري الإرسال..." : "إرسال الطلب"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default DeleteAccount;
